import { __rest } from "tslib";
import React from 'react';
import Money from '../Money';
import { formatCompactMoneyAmount } from '../../utils';
const CompactMoney = (_a) => {
    var { 
    /* Если длина строки "цены" >= abbreviationThreshold, сокращаем */
    abbreviationThreshold = 6, compactAmountRenderer, compactCurrencyRenderer } = _a, moneyProps = __rest(_a, ["abbreviationThreshold", "compactAmountRenderer", "compactCurrencyRenderer"]);
    const amountRenderer = (amount, currency) => {
        const render = compactAmountRenderer || formatCompactMoneyAmount;
        return render(amount, currency, abbreviationThreshold);
    };
    const currencyRenderer = compactCurrencyRenderer
        ? (currency) => { var _a; return compactCurrencyRenderer(currency, (_a = moneyProps === null || moneyProps === void 0 ? void 0 : moneyProps.money) === null || _a === void 0 ? void 0 : _a.amount, abbreviationThreshold); }
        : undefined;
    return React.createElement(Money, Object.assign({ amountRenderer: amountRenderer, currencyRenderer: currencyRenderer }, moneyProps));
};
export default CompactMoney;
